export const UNIT_STATUS_OPTIONS = {
  'ACTIVE': {
    color: '#10B981',
    bgColor: '#ECFDF5',
    label: 'Aktiv',
    value: 'ACTIVE'
  },
  'INACTIVE': {
    color: '#6B7280',
    bgColor: '#F9FAFB',
    label: 'Inaktiv',
    value: 'INACTIVE'
  },
  'UNKNOWN': {
    color: '#F59E0B',
    bgColor: '#FEF3C7',
    label: 'Unbekannt',
    value: 'UNKNOWN'
  },
  'IN_PROCESS': {
    color: '#3B82F6',
    bgColor: '#DBEAFE',
    label: 'in Bearbeitung',
    value: 'IN_PROCESS'
  },
  'TO_BE_INSTALLED': {
    color: '#EF4444',
    bgColor: '#FEF2F2',
    label: 'zu montieren',
    value: 'TO_BE_INSTALLED'
  },
  'INSTALLED': {
    color: '#059669',
    bgColor: '#D1FAE5',
    label: 'montiert',
    value: 'INSTALLED'
  },
  'CUSTOMER_REFUSES_REMOVAL': {
    color: '#DC2626',
    bgColor: '#FEE2E2',
    label: 'Kunde lehnt Demontage ab',
    value: 'CUSTOMER_REFUSES_REMOVAL'
  },
};